"use client";
import React from "react";
import { SxProps, Box, Theme } from "@mui/material";
import { FreeMode, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Image from "next/image";

export const PayImgWrapper: React.FC<{
  src: string;
  sx: SxProps<Theme>;
}> = ({ src, sx }) => {
  return (
    <Box
      className="pay-img-wrapper"
      sx={{
        ...sx,
        img: {
          height: "auto",
          width: "100%",
          objectFit: "contain",
          mt: "6px",
        },
      }}
    >
      <Image src={src} width={100} height={50} alt="We accept Payments" loader={({ src }) => src} />
    </Box>
  );
};

export const PaymentIconsHeaderMobile: React.FC<{
  sx?: SxProps<Theme>;
}> = React.memo(({ sx }) => {
  const SuperpayImg = "/images/payment-header-mobile/superpay.png";
  const AmexImg = "/images/payment-header-mobile/amex.png";
  const ApplePayImg = "/images/payment-header-mobile/apple-pay.png";
  const ClearPayImg = "/images/payment-header-mobile/clearpay.png";
  const DirectDebitImg = "/images/payment-header-mobile/direct-debit.png";
  const GPayImg = "/images/payment-header-mobile/gpay.png";
  const KlarnaImg = "/images/payment-header-mobile/klarna.png";
  const LinkImg = "/images/payment-header-mobile/link.png";
  const MaestroImg = "/images/payment-header-mobile/maestro.png";
  const MasterCardImg = "/images/payment-header-mobile/master-card.png";
  const PaypalImg = "/images/payment-header-mobile/paypal.png";
  const VisaImg = "/images/payment-header-mobile/visa.png";

  return (
    <>
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          display: { xs: "flex", md: "none" },
          justifyContent: "center",
          transition: "all 0.5s",
          width: "100%",
          p: { xs: "14px 0px 10px", sm: "3px 0px" },
          borderTop: "1px solid #c9e1ff",
          borderBottom: "1px solid #c9e1ff",
          "& .swiper-wrapper": {
            height: "fit-content",
          },
          height: "fit-content",
          // overflow: "hidden",
          background:
            "linear-gradient(90deg, rgb(237 246 254) 0%, rgb(245 238 255) 50%, rgb(237 245 255) 100%)",
          ".pay-img-wrapper": {
            position: "relative",
            height: { xs: "36px", sm: "45px" },
            img: {
              objectFit: "contain",
            },
          },
          ...sx,
        }}
      >
        <Box
          sx={{
            width: "fit-content",
            minWidth: "85px",
            fontSize: { xs: "11px", md: "1.1rem" },
            fontWeight: { xs: 500, md: 600 },
            mb: { xs: "-4px", md: "0px" },
            letterSpacing: { xs: "0px", md: "0px" },
            mt: { xs: "-8px", sm: "0px" },
            mr: "0px",
            textTransform: "initial",
            position: "absolute",
            top: { xs: "0px", sm: "-14px" },
            borderRadius: "4px",
            color: { xs: "#0c52cb", md: "#000" },
            p: "2px 4px 0px",
            textAlign: "center",
            bgcolor: "#fff1",
            backdropFilter: "blur(4px)",
            fontFamily: "'blauerNue', 'blauerNue Fallback'",
          }}
        >
          Payments We Accept
        </Box>

        <Box sx={{ maxWidth: "100vw" }}>
          <Box
            sx={{
              position: "relative",
              ".swiper-wrapper": {
                transitionTimingFunction: "linear",
              },
              ".swiper-slide": {
                width: "fit-content !important",
                flexShrink: "100 !important",
              },
            }}
          >
            <Swiper
              modules={[FreeMode, Autoplay]}
              freeMode={true}
              loop={true}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
              }}
              slidesPerView="auto"
              spaceBetween={12}
              speed={5000}
            >
              <SwiperSlide>
                <PayImgWrapper src={SuperpayImg} sx={{ width: "80px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={VisaImg} sx={{ width: "55px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={MasterCardImg} sx={{ width: "28px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={MaestroImg} sx={{ width: "28px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={AmexImg} sx={{ width: "22px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={GPayImg} sx={{ width: "46px", ml: "-2px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={ApplePayImg} sx={{ width: "39px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={PaypalImg} sx={{ width: "80px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={KlarnaImg} sx={{ width: "60px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={ClearPayImg} sx={{ width: "72px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={LinkImg} sx={{ width: "44px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={DirectDebitImg} sx={{ width: "68px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={SuperpayImg} sx={{ width: "80px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={VisaImg} sx={{ width: "55px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={MasterCardImg} sx={{ width: "28px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={MaestroImg} sx={{ width: "28px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={AmexImg} sx={{ width: "22px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={GPayImg} sx={{ width: "46px", ml: "-2px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={ApplePayImg} sx={{ width: "39px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={PaypalImg} sx={{ width: "80px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={KlarnaImg} sx={{ width: "60px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={ClearPayImg} sx={{ width: "72px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={LinkImg} sx={{ width: "44px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={DirectDebitImg} sx={{ width: "68px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={SuperpayImg} sx={{ width: "80px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={VisaImg} sx={{ width: "55px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={MasterCardImg} sx={{ width: "28px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={MaestroImg} sx={{ width: "28px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={AmexImg} sx={{ width: "22px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={GPayImg} sx={{ width: "46px", ml: "-2px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={ApplePayImg} sx={{ width: "39px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={PaypalImg} sx={{ width: "80px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={KlarnaImg} sx={{ width: "60px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={ClearPayImg} sx={{ width: "72px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={LinkImg} sx={{ width: "44px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={DirectDebitImg} sx={{ width: "68px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={SuperpayImg} sx={{ width: "80px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={VisaImg} sx={{ width: "55px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={MasterCardImg} sx={{ width: "28px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={MaestroImg} sx={{ width: "28px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={AmexImg} sx={{ width: "22px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={GPayImg} sx={{ width: "46px", ml: "-2px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={ApplePayImg} sx={{ width: "39px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={PaypalImg} sx={{ width: "80px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={KlarnaImg} sx={{ width: "60px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={ClearPayImg} sx={{ width: "72px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={LinkImg} sx={{ width: "44px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={DirectDebitImg} sx={{ width: "68px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={SuperpayImg} sx={{ width: "80px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={VisaImg} sx={{ width: "55px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={MasterCardImg} sx={{ width: "28px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={MaestroImg} sx={{ width: "28px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={AmexImg} sx={{ width: "22px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={GPayImg} sx={{ width: "46px", ml: "-2px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={ApplePayImg} sx={{ width: "39px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={PaypalImg} sx={{ width: "80px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={KlarnaImg} sx={{ width: "60px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={ClearPayImg} sx={{ width: "72px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={LinkImg} sx={{ width: "44px" }} />
              </SwiperSlide>

              <SwiperSlide>
                <PayImgWrapper src={DirectDebitImg} sx={{ width: "68px" }} />
              </SwiperSlide>
            </Swiper>
          </Box>
        </Box>
      </Box>
    </>
  );
});
PaymentIconsHeaderMobile.displayName = "PaymentIconsHeaderMobile";
